/** React Query key for lightweight hierarchy inbox fetch (unread badge + invalidation). */
export const HIERARCHY_INBOX_SUMMARY_QUERY_KEY = ['hierarchy-messages', 'inbox-summary'];
